import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import Card from "react-bootstrap/cjs/Card";
import Table from "react-bootstrap/cjs/Table";
import { CloseButton } from "react-bootstrap";

const StateHistory = () => {
  const _history = useRef([]);

  const location = useLocation();

  const [show, setShow] = useState(true);

  useEffect(() => {
    _history.current.push(location);
  }, [location]);

  if (true || process.env.NODE_ENV !== "development" || !show) return null;

  const hide = () => {
    setShow(false);
  };

  return (
    <Card>
      <Card.Header>
        Location History (this won't show in production)
        <CloseButton onClick={hide} />
      </Card.Header>
      <Card.Body>
        <Table striped bordered size={"sm"}>
          <tbody>
            {_history.current.map(
              (item, i) =>
                !!item && (
                  <tr key={i}>
                    <td>
                      <pre>{JSON.stringify(item, null, 2)}</pre>
                    </td>
                  </tr>
                )
            )}
          </tbody>
        </Table>
      </Card.Body>
    </Card>
  );
};

export default StateHistory;
